import React from 'react';

import ProcessTaskDetailsOutputs from './ProcessTaskDetailsOutputs';

export default function ProcessTaskDetailsOutputsTabView({
  processTaskId,
}: {
  processTaskId: string;
}): JSX.Element {
  return (
    <div className="react-tab-container">
      <ProcessTaskDetailsOutputs processTaskId={processTaskId} />
    </div>
  );
}
